module.exports = __webpack_public_path__ + "4d70a50002fe2be1df88d491d86f0006.png";